import envConfig from './env-config'

export function getInvestibookWorkspaceEntryUrl(clusterId: string) {
  const base = envConfig.quickLinks.investibook.replace(/\/+$/, '')
  const url = new URL('/workspace/new', base)

  url.searchParams.set('cluster_id', clusterId)
  url.searchParams.set('source', 'clinic')

  return url.toString()
}
